import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavQuestionIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6156_510)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M20.5312 5.99609C22.9981 5.99609 24.998 7.99602 24.998 10.4629V20.4844C24.998 22.9512 22.9981 24.9512 20.5312 24.9512H10.5098C8.04289 24.9512 6.04297 22.9512 6.04297 20.4844V10.4629C6.04297 7.99602 8.04289 5.99609 10.5098 5.99609H20.5312Z",
				fill: "#354C8F",
				stroke: "#354C8F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.0938 3.57031C20.5606 3.57031 22.5605 5.57024 22.5605 8.03711V18.0586C22.5605 20.5255 20.5606 22.5254 18.0938 22.5254H8.07227C5.60539 22.5254 3.60547 20.5255 3.60547 18.0586V8.03711C3.60547 5.57024 5.60539 3.57031 8.07227 3.57031H18.0938Z",
				fill: "#E2EDFF",
				stroke: "#354C8F",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5586 10.1009C10.5586 10.1009 10.7219 8.19922 13.1136 8.19922C15.5053 8.19922 16.1003 10.4276 15.2019 11.7926C14.5253 12.8192 12.8453 13.2626 12.8453 15.5726",
				stroke: "#354C8F",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.8438 17.8477V17.8943",
				stroke: "#354C8F",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6156_510",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			fill: "white"
		})
	}) })]
});
export default SvgNavQuestionIcon;
